var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { EmploymentType, JobApplicationStatus, JobPostingStatus, MimeType } from "../../model";
import { EmailTemplateDTO } from "./email-template.dto";
import { PositionDTO } from "./position.dto";
import { safeAssign } from "./safe-assign";
export class JobApplicationDocumentDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDocumentDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDocumentDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDocumentDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDocumentDTO.prototype, "downloadUrl", void 0);
export class JobApplicationDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobApplicationDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobApplicationDTO.prototype, "postingId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "firstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "lastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "address", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "postalCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "city", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "email", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "phone", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobApplicationDTO.prototype, "birthday", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobApplicationDTO.prototype, "availableFrom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "headShot", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "headShotUrl", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "message", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobApplicationDTO.prototype, "notes", void 0);
__decorate([
    Expose(),
    Type(() => JobApplicationDocumentDTO),
    __metadata("design:type", Array)
], JobApplicationDTO.prototype, "documents", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], JobApplicationDTO.prototype, "created", void 0);
export class JobPostingDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingDTO.prototype, "uuid", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingDTO.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingDTO.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingDTO.prototype, "companyId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingDTO.prototype, "payType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingDTO.prototype, "payAmount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingDTO.prototype, "end", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingDTO.prototype, "employmentType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingDTO.prototype, "hoursPerWeek", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], JobPostingDTO.prototype, "imageUrls", void 0);
__decorate([
    Expose(),
    __metadata("design:type", EmailTemplateDTO)
], JobPostingDTO.prototype, "submissionConfirmationEmailTemplate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", EmailTemplateDTO)
], JobPostingDTO.prototype, "rejectionEmailTemplate", void 0);
__decorate([
    Expose(),
    Type(() => PositionDTO),
    __metadata("design:type", Array)
], JobPostingDTO.prototype, "positions", void 0);
__decorate([
    Expose(),
    Type(() => JobApplicationDTO),
    __metadata("design:type", Array)
], JobPostingDTO.prototype, "applications", void 0);
export class GetJobPostingsParams {
    constructor(props) {
        Object.assign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], GetJobPostingsParams.prototype, "includeArchived", void 0);
export class JobPostingListItemDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingListItemDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingListItemDTO.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingListItemDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingListItemDTO.prototype, "employmentType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingListItemDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    Type(() => PositionDTO),
    __metadata("design:type", Array)
], JobPostingListItemDTO.prototype, "positions", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingListItemDTO.prototype, "applicationsCount", void 0);
//# sourceMappingURL=recruiting.app.dto.js.map